module.exports = __webpack_public_path__ + "86672199109718f8acb41e971ffa67e8.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/image/Carroussel/widget/Panorama-saison-EN.png
// module id = 514
// module chunks = 0